<template>
  <div class="first-section">
    <h2>{{ $ml.get(`Tank Distribution`) }}</h2>
    <!-- //=========================================================================================== -->
    <h4 style="font-weight:normal;">{{ $ml.get(`By default, the number of tank applications is equal to the selected stage's duration.`) }}</h4>
<h4 style="font-weight:normal;">{{ $ml.get(`Changing the tank volume will set applications to the minimum safe number without hazards.`) }}</h4>
<!-- //=========================================================================================== -->
    <div class="dists" :class="{blur : (!$store.getters['user/data'].subsPlan)}">
      <app-btn 
        to="/dashboard/plans" 
        class="go-to-plans" 
        v-if="!$store.getters['user/data'].subsPlan"
      >{{$ml.get(`Get the full access to the software`)}}</app-btn>

      <TankDistItem
        :data="item"
        v-for="(item, i) in tanks"
        :key="i"
      />
    </div>
  </div>
</template>

<script>
import TankDistItem from './TankDistItem';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {
    TankDistItem,
  },
  computed: {
    ...mapGetters({
      tanks: 'program/fertigation/tanks'
    }),
  }
}
</script>

<style lang="scss" scoped>

.first-section {

  
  // padding: 0 48px;
  padding-top: 50px;

  .title {
    font-size: 22px;
    font-weight: bold;
  }

  .dists {

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;

    padding-top: 10px;

    .tank-dist-item {
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }

  .buttons {

    padding-top: 50px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .next {
      margin-left: 20px;
    }
  }
  @media (max-width: 768px) {
    padding-top: 24px;
    .dists {
      overflow-x: hidden;
      padding-top: 0;
      padding-bottom: 16px;
    }
    .buttons {
      padding-top: 24px;
    }
  }
}

</style>
